import React from 'react';

const InfoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    {...props}
  >
    <path
      d="M12.8327 6.49992C12.8327 3.27826 10.221 0.666584 6.99935 0.666584C3.77769 0.666584 1.16602 3.27826 1.16602 6.49992C1.16602 9.72158 3.77769 12.3333 6.99935 12.3333C10.221 12.3333 12.8327 9.72158 12.8327 6.49992Z"
      stroke="#002564"
      strokeWidth="0.875"
      opacity="0.5"
    />
    <path
      d="M7.13997 9.41675V6.50008C7.13997 6.2251 7.13997 6.0876 7.05455 6.00218C6.96912 5.91675 6.83163 5.91675 6.55664 5.91675"
      stroke="#002564"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.5"
    />
    <path
      d="M6.99403 4.16675H6.99927"
      stroke="#002564"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.5"
    />
  </svg>
);

export default InfoIcon;